
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/popup/referral-gift",
      function () {
        return require("private-next-pages/popup/referral-gift.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/popup/referral-gift"])
      });
    }
  